import {get, post} from '~/utils/request';

export function getLastUserList(data) {
  return post('/Chat/GetLastContactList', data);
}

export function getChatList(data) {
  return post('/Chat/GetList', data);
}

export function sendMessage(data) {
  return post('/Chat/SendMessage', data);
}

export function readOneChat(data) {
  return post('/Chat/ReadOneChat', data);
}

export function meSimpleInfo(data) {
  return post('/Chat/MeDataSimpleInfo', data);
}

export function readChat(data) {
  return post('/Chat/ReadChat', data);
}

export function isContact(data) {
  return post('/Chat/IsContact', data);
}

export function isExchangedMobile(data) {
  return post('/Chat/IsExchangedMobile', data);
}

export function chatUserInfo(data) {
  return post('/Chat/GetChatViewInfoByUser', data);
}

export function getJobId(data) {
  return post('/Chat/GetJobID', data);
}

export function defaultInviteInfo(data) {
  return post('/Chat/DefaultInviteSimpleInfo', data);
}
